<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="550"
    >
      <v-card>
        <v-card-title class="headline" id="card-title">
           <div>
             <v-icon class="my-5" color="teal darken-1" large>mdi-checkbox-marked-circle</v-icon>本人確認メールを送信しました。
          </div>
<!--          正常に登録されました。<br> -->
<!--           <p v-html="successText"></p> -->
         </v-card-title>
         <v-card-text>
          <div class="body-1 black--text">
             {{username}} 様に以下のメールを送信しました。<br>
          </div>
<!--
          <div class="body-1 red--text">
             <br>
             下記の初期パスワードが設定されておりますので<br>
             ご利用開始手続きのご案内とともにご本人様にご連絡をお願いします。
             <br>
          </div>
 -->
          <div class="body-3 ml-3" style="margin-top: 10px ">
            メールアドレス<br>
          </div>
          <div class="body-1 black--text ml-5">
            {{ email }}<br>
          </div>
 
          <div class="body-3 ml-3" style="margin-top: 10px ">
            送信メール<br>
          </div>
          <div class="body-2 black--text ml-5">
             ・本人確認コード<br>
             ・利用開始手続きのご案内メール
          </div>

          <!--
          <div class="body-3" style="margin-top: 10px ">
            初期パスワード<br>
          </div>
          <div class="body-1 black--text">
            {{ password }}<br>
          </div>
          <div class="body-3" style="margin-top: 10px ">
             ご利用開始手順と合わせたメール本文のサンプル<br>
          </div>
          <div class="caption red--text" style="margin-top: 0">
             ※メールアドレス、パスワードが埋め込まれておりますのでご注意ください。<br>
          </div>
          <v-textarea v-model="sampleBody"
            filled
            readonly
            id="sampleBody"
            class="caption mb-5 "
            hide-details
          >
          </v-textarea>

          <v-btn
            color="teal darken-1"
            rounded
            @click="copyToClipboard()"
            class="white--text"
            small
          >
            ご案内メールのサンプルをコピー
          </v-btn>

          {{copyresult}}
-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            color="amber darken-1" 
            @click="showDialog()"

            class="mb-5 px-2"
          >
            {{ buttonName }}戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["username", "email","password","sampleBody", "successText"],
    data: () => ({
        isSuccessed: false,
        buttonName: '',
        copyresult: ""
    }),
    mounted: async function () {
    },
    methods: {
      showDialog() {
          this.isSuccessed = false
          this.$router.push("/employeeList")
      },
      open() {
        this.buttonName = "担当者一覧へ"
        this.isSuccessed = true
      },
      copyToClipboard() {
            // コピー対象をJavaScript上で変数として定義する
            var copyTarget = document.getElementById("sampleBody");

            // コピー対象のテキストを選択する
            copyTarget.select();

            // 選択しているテキストをクリップボードにコピーする
            document.execCommand("Copy");

            // コピーをお知らせする
            this.copyresult = "メール本文の例コピーしました"

        }
    }
}
</script>

